import React from 'react';

import PropTypes from 'prop-types';
import { RadioGroup } from '@telus-uds/components-web';

import { useLocaleContext } from '../../../context/LocaleContext';
import EN from '../../../../EN.json';
import FR from '../../../../FR.json'; 

const DefectCategory = ({
  fieldData,
  setFieldData,
  formErrors,
  setFormErrors
}) => {
  const locale = useLocaleContext();
  const {
    reportIssue: {
        form: {
            labelDefectCategory,
            labelDefectCategoryOptionUserInfo,
            labelDefectCategoryOptionOffersPricing,
            labelDefectCategoryOptionBehaviouralIssue
          }
    }
  } = locale === 'en-US' ? EN : FR;
  const fieldError = 'defectCategory' in formErrors;
  const fieldOptions = [
    labelDefectCategoryOptionUserInfo,
    labelDefectCategoryOptionOffersPricing,
    labelDefectCategoryOptionBehaviouralIssue
  ];

  // Convert options to RadioGroup items format: { label, id }
  const items = fieldOptions.map(option => ({
    label: option,
    id: option
  }));

  const handleSelect = (value) => {
    if (value) {
      setFormErrors(previousValue => {
        const updatedValues = { ...previousValue };
        delete updatedValues.defectCategory;
        return updatedValues;
      });
      setFieldData(previousValue => ({
        ...previousValue,
        defectCategory: value
      }));
    }
  };

  return (
    <div>
      <RadioGroup
        legend={`${labelDefectCategory} *`}
        items={items}
        checkedId={fieldData.defectCategory || null}
        onChange={handleSelect}
        name="defectCategory"
        validation={fieldError ? 'error' : undefined}
        feedback={fieldError ? formErrors.defectCategory.message : undefined}
      />
    </div>
  );
};

DefectCategory.propTypes = {
  formErrors: PropTypes.shape({
    defectCategory: PropTypes.shape({
      message: PropTypes.string
    })
  }).isRequired,
  setFormErrors: PropTypes.func.isRequired,
  setFieldData: PropTypes.func.isRequired,
  fieldData: PropTypes.shape({
    defectWebform: PropTypes.string,
    defectCategory: PropTypes.string,
    priority: PropTypes.string,
    issueSummary: PropTypes.string,
    errorMessage: PropTypes.string,
    stepsToReplicate: PropTypes.string,
    attachment: PropTypes.string
  }).isRequired
};

export default DefectCategory;
